import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HomePage } from './Routes/HomePage';
import { LoginPage } from './Routes/LoginPage';
import { Dashboard } from './Routes/Dashboard';
import { Redirect } from './Components/Redirect';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/app" element={<App/>}/>
      <Route path="/" element={<HomePage/>}/>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/redirect" element={<Redirect/>} />
    </Routes>
  </BrowserRouter>
);

